module.exports = __webpack_public_path__ + "static/media/back.9df4ea59.svg";